import { useMemo } from 'react'
import { TokenBalance } from '../../../../../graphql/generated/graphql'
import { useWeb3Connection } from '../../../../../web3/Web3Provider'
import { useTokenPriority } from '../../../../app/feature'
import { SHITCOIN_BLACKLIST } from '../tokenBlacklist'
import { uniqueTokenBalances } from '../utils'

export const usePaymentTokens = (allTokenBalances: TokenBalance[]) => {
    const { connectedNetwork } = useWeb3Connection()
    const prioritizedTokens = useTokenPriority()

    const tokenBalances = useMemo(() => {
        if (!connectedNetwork) return []
        return uniqueTokenBalances(
            allTokenBalances
                .filter((balance) => !SHITCOIN_BLACKLIST.has(balance.address.toLowerCase()))
                .sort((a, b) => b.balanceUSD - a.balanceUSD)
                .sort((a, b) => {
                    const aP = prioritizedTokens.includes(a.symbol) ? 1 : 0
                    const bP = prioritizedTokens.includes(b.symbol) ? 1 : 0
                    return bP - aP
                }) ?? []
        )
    }, [allTokenBalances, connectedNetwork, prioritizedTokens])

    return tokenBalances
}
